import {IFilm} from "@/interfaces/film.interface";
import {MainPageConfig} from "@/interfaces/main-page.interface";

export namespace ThemePathPageConfig {

  export interface IThemePathPageConfig {
    entity_id: string;
    title: string;
    description: string;
    illustration: string;
    content: ThemePathPageBlocks[];
  }

  export type ThemePathPageBlocks = ICombinedPlayer | IFilms | IQuote | IGallery | MainPageConfig.IImage | MainPageConfig.IText | ICustomVideo;

  export interface ICombinedPlayer {
    type: MainPageConfig.PageBlockTypes;
    combi_player: {
      title: string;
      text: string;
      film_left_col: IFilm;
      film_right_col: IFilm;
    }
  }

  export interface IFilms {
    type: MainPageConfig.PageBlockTypes;
    films: {
      view_mode: FilmViewModes;
      film: IFilm;
    }
  }

  export interface ICustomVideo {
    type: MainPageConfig.PageBlockTypes;
    custom_video: {
      view_mode: FilmViewModes;
      video: IFilm;
    }
  }

  export enum FilmViewModes {
    CENTER = 'full_width',
    LEFT = 'sidebar_video_left',
    RIGHT = 'sidebar_video_right'
  }

  export interface IQuote {
    type: MainPageConfig.PageBlockTypes;
    quote: {
      quote: string;
      quote_footer: string;
    }
  }

  export interface IGallery {
    type: MainPageConfig.PageBlockTypes;
    gallery: {
      title: string;
      text: string;
      images: string[];
    }
  }
}
